'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var palette = theme.palette;


    var tab = {
        display: 'flex',
        alignItems: theme.tabAlignItems,
        justifyContent: theme.tabJustifyContent,
        borderBottom: theme.tabBorderWidth + ' ' + theme.tabBorderStyle + ' ' + theme.tabBorderColor,
        transitionProperty: 'border, color',
        transitionDuration: palette.transitionDuration,
        transitionTimingFunction: palette.transitionFunction,
        paddingTop: theme.tabPaddingTop,
        paddingBottom: theme.tabPaddingBottom,
        paddingLeft: theme.tabPaddingLeft,
        paddingRight: theme.tabPaddingRight,
        color: theme.tabColor,
        fontSize: theme.tabFontSize,
        lineHeight: theme.tabLineHeight,
        fontWeight: theme.tabFontWeight,
        cursor: theme.tabCursor,

        '&:not(:last-child)': {
            marginRight: theme.tabMarginRight
        },

        '&:hover': {
            borderBottom: theme.hoverTabBorderWidth + ' ' + theme.hoverTabBorderStyle + ' ' + theme.hoverTabBorderColor,
            fontSize: theme.hoverTabFontSize,
            lineHeight: theme.hoverTabLineHeight,
            fontWeight: theme.hoverTabFontWeight,
            cursor: theme.hoverTabCursor,
            color: theme.hoverTabColor
        }
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            fontFamily: theme.fontFamily,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight
        },
        tabsContainer: {
            display: 'flex',
            alignItems: theme.tabsAlignItems,
            justifyContent: theme.tabsJustifyContent,
            overflowX: 'auto'
        },
        tab: tab,
        activeTab: Object.assign({}, tab, {
            borderBottom: theme.activeTabBorderWidth + ' ' + theme.activeTabBorderStyle + ' ' + theme.activeTabBorderColor,
            fontSize: theme.activeTabFontSize,
            lineHeight: theme.activeTabLineHeight,
            fontWeight: theme.activeTabFontWeight,
            cursor: theme.activeTabCursor,
            color: theme.activeTabColor,

            '&:hover': {}
        })
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        tabsContainer: (0, _aphroditeJss.css)(styleList.tabsContainer),
        tab: (0, _aphroditeJss.css)(styleList.tab),
        activeTab: (0, _aphroditeJss.css)(styleList.activeTab)
    };
};

var _aphroditeJss = require('aphrodite-jss');